import { createSlice } from "@reduxjs/toolkit"
import apiHistorySystem from "api/history-system"
import store from "store/store";
import { SLICE_NAME } from "constants/common";
import { setShowBackdrop } from "store/commonSlice";
import { ARRAY_TABS_LOG } from "../constant";
import { DEFAULT_TIMESEARCH } from "constants/search";
import moment from 'moment';

export const fetchData = async (data, type) => {
    try {
        let res
        store.dispatch(setShowBackdrop(true))
        switch (type) {
            case ARRAY_TABS_LOG[0]:
                res = await apiHistorySystem.getListHistoryLogin(data)
                break
            case ARRAY_TABS_LOG[1]:
                res = await apiHistorySystem.getListHistoryLogin(data)
                break
            case ARRAY_TABS_LOG[2]:
                res = await apiHistorySystem.getListErrorLog(data)
                break
            case ARRAY_TABS_LOG[3]:
                res = await apiHistorySystem.getListHistoryAction(data)
                break
            case ARRAY_TABS_LOG[4]:
                res = await apiHistorySystem.getListHistoryAction(data)
                break
            case ARRAY_TABS_LOG[5]:
                res = await apiHistorySystem.getListHistoryAction(data)
                break
            case ARRAY_TABS_LOG[6]:
                res = await apiHistorySystem.getUpdate2FA(data)
                break
            default:
                res = await apiHistorySystem.getMyHistoryLogin(data)
                break;
        }
        if (res.status === 200) {
            store.dispatch(setTableData({
                data: res.data,
                total: res.total
            }))
        }
        else console.log("info: ", res);
    } catch (err) {
        console.log("err: ", err)
    } finally {
        store.dispatch(setShowBackdrop(false))
    }
}

const initialState = {
    tableData: {
        data: [],
        total: 0
    },
    timesearch: {
        startDate: DEFAULT_TIMESEARCH.startDate.valueOf(),
        endDate: DEFAULT_TIMESEARCH.endDate.valueOf()
    },
    query: {
        username: ''
    },
    currentTab: 0
}

export const accessLogSlice = createSlice({
    name: SLICE_NAME.ACCESS_LOG,
    initialState,
    reducers: {
        setTableData: (state, action) => void (state.tableData = action.payload),
        setTimeSearch: {
            reducer: (state, action) => void (state.timesearch = action.payload),
            prepare: (value) => ({ payload: {
                startDate: moment(value.startDate).valueOf(),
                endDate: moment(value.endDate).valueOf(),
            } }),
        },
        setQuery: (state, action) => void (state.query = action.payload),
        setCurrentTab: (state, action) => void (state.currentTab = action.payload)
    }
})

export const { setTableData, setTimeSearch, setQuery, setCurrentTab } = accessLogSlice.actions
export default accessLogSlice.reducer
